import * as Yup from "yup";
import { campo_obligatorio } from "../../utils/traductor";

export function initialValues(state) {
  return {
    nombre: state.nombre,
    email: state.email,
    telefono: state.telefono,
    logo: state.logo,
    localidad: state.localidad,
    activo: state.activo,
  };
}

export function validationSchema() {
  return Yup.object({
    nombre: Yup.string().required(` ${campo_obligatorio} `),
    email: Yup.string().required(` ${campo_obligatorio} `),
    telefono: Yup.string().required(` ${campo_obligatorio} `),
    localidad: Yup.string().required(` ${campo_obligatorio} `),
  });
}
